import React from 'react'

const Loader = () => {
  return (
    <div className='loader-style'>Loader</div>
  )
}

export default Loader